module.exports = __webpack_public_path__ + "b277a17049ac86292c1f204031ee348e.png";